module.exports = __webpack_public_path__ + "static/IMG_2585-9bd4e9aef73b9a5c3db006cb182f77aa.jpg";